import React, { Component } from 'react'
import { Col, Row } from '../../atoms-v2/Grid'
import Font from '../../atoms/Font'
import ImageRatio from '../../atoms/ImageRatio'

import style from './style.css'

export default class ItemKit extends Component {

   render() {
      const { full } = this.props
      return (
         <div style={{ padding: '30px 0 0 0', maxWidth: '100%' }}>
            <Row>
                  <Col>
                        <Row>
                              <Col size={full ? '12 6' : '12' }>
                                    <div style={{ backgroundColor: '#f9f9f9', cursor: `${this.props.handleClick ? 'pointer' : 'default'}` }} onClick={() => { if(this.props.handleClick) this.props.handleClick() } }>
                                          <ImageRatio image={this.props.image} />
                                    </div>
                              </Col>
                        
                              <Col size={full ? '12 6' : '12' }>          
                                    <div
                                          className={style.title}
                                          style={{
                                                textAlign: `${!full ? 'center' : 'left'}`,
                                                marginTop: `${full ? 0 : ''}`
                                                }}>
                                          <Font upper="true" weight="bold" size={20} color="#545454"> { this.props.title } </Font>
                                    </div>
                                    <div className={style.content} style={{textAlign: `${!full ? 'center' : 'left'}`}}>
                                          <Font size={14} color="#545454">
                                                { this.props.content } 
                                          </Font>
                                    </div>
                              </Col>
                        </Row>
                  </Col>
            </Row>
         </div>
      )
   }
}


// WEBPACK FOOTER //
// ./src/components/molecules/ItemKit/index.js